/**
 * Saudação e nome de tratamento da home de canais.
 *
 * `greetingFor` recebe a data por PARÂMETRO em vez de chamar `new Date()` por
 * dentro — é o que torna as fronteiras de faixa testáveis sem mockar o relógio.
 */

const MORNING_START = 5
const AFTERNOON_START = 12
const EVENING_START = 18

/** Faixas: 05–11 "Bom dia", 12–17 "Boa tarde", resto "Boa noite". */
export function greetingFor(date: Date): string {
  const hour = date.getHours()
  if (hour >= MORNING_START && hour < AFTERNOON_START) return 'Bom dia'
  if (hour >= AFTERNOON_START && hour < EVENING_START) return 'Boa tarde'
  return 'Boa noite'
}

/**
 * Primeiro nome, pra saudação soar pessoal sem virar formulário.
 * Devolve `''` quando não há nome utilizável — quem chama decide o fallback,
 * porque a saudação sem nome ("Boa tarde") é válida e a com vazio ("Boa tarde, ")
 * não é.
 */
export function firstName(fullName: string): string {
  return fullName.trim().split(/\s+/)[0] ?? ''
}
